declare global {
  interface Window {
    __SUNDIUS_PATH_PREFIX?: string;
  }
}

/** Public API mount — same origin under /sundius when deployed. */
export function apiPrefix(): string {
  if (typeof window !== "undefined" && window.__SUNDIUS_PATH_PREFIX) {
    return window.__SUNDIUS_PATH_PREFIX;
  }
  return import.meta.env.DEV ? "/sundius" : "/sundius";
}

export function apiUrl(path: string): string {
  const base = apiPrefix();
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${base}${normalized}`;
}

export function appBase(): string {
  return `${apiPrefix()}/app/`;
}

/** Universal branded share page (web + iPhone) — use in Messages. */
export const JOIN_URL = "https://kyleauger.com/sundius/join";

/** @deprecated Prefer JOIN_URL */
export const APP_STORE_URL = JOIN_URL;

export const VALID_MODES = [
  "easy",
  "medium",
  "hard",
  "ultra",
  "everyone",
  "birth_order_easy",
  "birth_order_medium",
  "birth_order_ultra",
  "family_match",
  "family_lore",
  "whos_with_who",
] as const;

export type QuizMode = (typeof VALID_MODES)[number];

export const STORAGE_KEYS = {
  deviceId: "sundius_web_device_id",
  session: "sundius_web_session",
  pendingAccess: "sundius_pending_access_request_id",
  openingSeen: "sundius_opening_seen",
  openingSeenAt: "sundius_opening_seen_at",
  tabIntros: "sundius_tab_intros_seen",
  birthdayReminders: "sundius_birthday_reminders",
  birthdayPrimingSeen: "sundius_birthday_priming_seen",
} as const;

/** iOS quick-return grace: 5 minutes */
export const OPENING_QUICK_RETURN_MS = 5 * 60 * 1000;
